import cls from "@fvilers/cls";
import { isEqual } from "radashi";
import { ComponentPropsWithRef, useState } from "react";
import styles from "./FieldErrors.module.css";

export type FieldError = (string | undefined)[] | string | null | undefined;

type FieldErrorsProps = {
  errorId?: string;
  errors: FieldError;
} & ComponentPropsWithRef<"div">;

export function FieldErrors({
  children,
  className,
  errorId,
  errors,
  ...props
}: FieldErrorsProps) {
  const normalizedErrors = [errors]
    .flat()
    .filter((value): value is string => Boolean(value));
  const hasErrors = normalizedErrors.length > 0;

  const [renderErrors, setRenderErrors] = useState(hasErrors);
  const [isLeaving, setIsLeaving] = useState(false);
  const [displayedErrors, setDisplayedErrors] = useState(normalizedErrors);

  if (
    !isEqual(displayedErrors, normalizedErrors) &&
    normalizedErrors.length > 0
  ) {
    setDisplayedErrors(normalizedErrors);
  }

  if (hasErrors && !renderErrors) {
    setRenderErrors(true);
  }

  if (renderErrors && !hasErrors && !isLeaving) {
    setIsLeaving(true);
  }

  return (
    <div className={cls(styles.FieldErrors, className)} {...props}>
      {children}
      {renderErrors && (
        <ul
          className={cls(styles.FieldError, isLeaving && styles.leaving)}
          data-testid="field-errors"
          id={errorId}
          onAnimationEnd={() => {
            if (isLeaving) {
              setRenderErrors(false);
              setIsLeaving(false);
              setDisplayedErrors([]);
            }
          }}
        >
          {displayedErrors.map(
            (error, index) => !!error && <li key={index}>{error}</li>,
          )}
        </ul>
      )}
    </div>
  );
}
